import t from '@zimpel/common/helpers/i18n';

import { AuthorizationError } from '@zimpel/common/newApi';
import { navigateTo } from '@zimpel/common/helpers/browser';
import { BugsnagIgnoredError } from '@zimpel/common/errors';
import { useNotificationContext } from '@zimpel/AppContext';

type HandleErrors = <T, >(cb: () => Promise<T>) => Promise<T>;

const useHandleErrors: () => HandleErrors = () => {
  const { notifyError } = useNotificationContext();

  return async (cb) => {
    try {
      return await cb();
    } catch (error) {
      if (error instanceof AuthorizationError) {
        navigateTo('/login');
        // This should be irrelevant, as we do a page reload,
        // but we can not return a value for typescript, and some
        // browsers actually do error handling for bugsnag still
        // before the page reload.
        throw new BugsnagIgnoredError();
      }

      notifyError(t('errors.messages.ups'));
      throw error;
    }
  };
};

export default useHandleErrors;
